"use strict";

exports.__esModule = true;
exports.getFirstDayOfTheWeek = getFirstDayOfTheWeek;
function getFirstDayOfTheWeek(locale) {
  const parts = locale == null ? void 0 : locale.match(/^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i);
  const [region, language] = [parts == null ? void 0 : parts[4], parts == null ? void 0 : parts[1]];
  const regionSat = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g);
  const regionSun = 'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(/../g);
  const languageSat = ['ar', 'arq', 'arz', 'fa'];
  const languageSun = 'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g);
  return region ? regionSun != null && regionSun.includes(region) ? 0 : regionSat != null && regionSat.includes(region) ? 6 : 1 : languageSun != null && languageSun.includes(language) ? 0 : languageSat != null && languageSat.includes(language) ? 6 : 1;
}
//# sourceMappingURL=weekStart.js.map